import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from '../auth/auth-token.service';
import { LoggerService } from '../shared/logger.service';
import { AuthService } from '../auth/auth.service';

export const homeSelectGuard: CanActivateFn = (route, state) => {
  let loggedIn = inject(AuthTokenService).isLoggedIn;
  let logger = inject(LoggerService);
  let router = inject(Router);
  logger.debug('homeSelectGuard...', loggedIn, route, state);
  // console.log('isLoggedInGuard...', loggedIn);
  if (!loggedIn) {
    // redirect to login page.
    let authService = inject(AuthService);
    return authService.checkRefreshToken()
      .then(secondIsLoggedIn => {
        logger.debug(`homeSelectGuard:secondIsLoggedIn:`, secondIsLoggedIn);
        if (!secondIsLoggedIn) {
          router.navigate(['home-logged-out']);
        }
        return secondIsLoggedIn;
      })
      .catch(err => {
        logger.error('homeSelectGuard...home logged out...');
        router.navigate(['home-logged-out']);
        return false;
      });
    // console.log('isLoggedInGuard...redirect to login...');
    // inject(AlertService).openSnackBar('Must be logged in to access this service');
    // inject(Router).navigate(['login'], {queryParams: {returnUrl: state.url}});
  } else {
    return Promise.resolve(loggedIn);
  }
  // return loggedIn;
  // if (!loggedIn) {
  //   // redirect to login page.
  //   // console.log('isLoggedInGuard...redirect to login...');
  //   // inject(AlertService).openSnackBar('Must be logged in to access this service');
  //   inject(Router).navigate(['home-logged-out']);
  // } else {
  //   // do nothing
  // }
  // return loggedIn;
};
